import useStyles from "isomorphic-style-loader/useStyles";
import React, { useEffect } from "react";
import { Iconfont } from "../../../../../../components/icon/iconfont";
import classes from './style.module.scss';

export const ChatInputBox = props => {
    useStyles(classes)
    const {intl, messageInvalid, textareaChange, message, handleImage, handleTicket, isApp} = props
    const bottomPx = (px) =>  `${2 * px / 75 * 1}rem`;

    const beforeHandleImage = (e) => {
        // console.log(e)
        handleImage(e)
    }

    return (
        <div className={classes.ChatInputBox} style={{bottom: isApp ? '0': bottomPx(74)}}>
            <div className={classes.ChatInput}>
                {/* innerRef={(ta)=>{this.textAreaRef=ta}} */}
                <input className={classes.TextInput} 
                    style={{boxShadow: messageInvalid && 'inset 0 0 1px red !important',borderColor: messageInvalid && 'red !important'}}
                    placeholder={intl.formatMessage({id:"textarea_placeholder"})}
                    onChange={(evt) => {textareaChange(evt) }} 
                    value={message}
                    onFocus={()=>{
                        document.body.scrollTop = document.body.scrollHeight
                    }}
                    onBlur={() => {window.scrollTo(0,0)}}
                    >
                </input>
            </div>
            <div className={classes.UploadBtn}>
                <label htmlFor="imageFiles">
                    <Iconfont className={classes.Upload}>&#xe788;</Iconfont>
                </label>
                <input style={{display:'none'}} id="imageFiles" name="imageFiles"
                        multiple="multiple" type="file"
                        accept="image/jpg,image/jpeg,image/png,image/gif"
                        onChange={beforeHandleImage}/>
            </div>
            <div className={classes.SendBtn} onClick={handleTicket}>
                <Iconfont className={classes.Send}>&#xe789;</Iconfont>
            </div>
        </div>
    )
}